module.exports = __webpack_public_path__ + "static/media/rate-1.756ed90d.svg";